export default {
  'pages.login.rateLimited': 'လော့ဂ်အင် အကြိမ်များလွန်းပါသည်။ {minutes} မိနစ်အကြာ ပြန်ကြိုးစားပါ။',
  'pages.dashboard.title': 'ဒက်ရှ်ဘုတ်',
  'common.noData': 'ဒေတာ မရှိသေးပါ',
  'common.fetchFailed': 'တောင်းဆိုမှု မအောင်မြင်ပါ',
};
